import React from 'react';
import { Section, FadeIn } from './ui';
import { Star } from 'lucide-react';
export const EarlyAdopterSection = () => {
  return <Section bg="bg-cream-light" data-id="element-95">
      <FadeIn data-id="element-96">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-md border border-cream-dark p-10 md:p-16 text-center" data-id="element-97">
          <div className="w-16 h-16 bg-gold-light/30 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-98">
            <Star className="w-8 h-8 text-gold fill-gold" data-id="element-99" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brown" data-id="element-100">
            Estás entre las primeras
          </h2>
          <div className="space-y-4 text-lg text-brown-light max-w-2xl mx-auto" data-id="element-101">
            <p data-id="element-102">
              Este es un lanzamiento nuevo. Tú podrías ser una de las primeras
              mujeres de 50+ en aplicar el Plan de 21 Días de Vitalidad y
              experimentar sus resultados. Tu experiencia nos ayudará a seguir
              mejorando este método para miles de mujeres como tú.
            </p>
            <p className="text-xl md:text-2xl text-gold font-bold italic pt-4" data-id="element-103">
              Las primeras siempre tienen ventaja.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};